import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const FullScreenOutwardIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.71508 7.28516L1.70508 10.2952"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M10.2952 1.70508L7.28516 4.71508"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M7.28516 7.28516L10.2952 10.2952"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M1.70508 1.70508L4.71508 4.71508"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
      />
      <path
        d="M7.70996 1.71094L10.29 1.71094V4.29094"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M4.28996 10.2909H1.70996L1.70996 7.71094"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M1.70996 4.29094L1.70996 1.71094L4.28996 1.71094"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M10.29 7.71094V10.2909H7.70996"
        stroke={color}
        strokeWidth={1.032}
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
